import Typography from '@pedidosya/web-fenix/foundations/Typography';
import styled from 'styled-components';
import { Row, TextSeparator } from '../styles/styles';
import { vendorItem as vendorItemTokens } from '../styles/vendorItem';

const textProps = vendorItemTokens.properties.fonts;

const TypographyTitle = styled(Typography)`
  &.ellipsis {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
  }
`;

export const CategoriesRow = ({ mainCategories }) => (
  <Row
    paddingBottom="spacing-component-xsmall"
    color={textProps.categories['text-color']}
  >
    <TypographyTitle
      className="ellipsis"
      token={textProps.categories.typography}
    >
      {mainCategories[0]}

      {mainCategories.length > 1 && (
        <>
          <TextSeparator>·</TextSeparator>
          {mainCategories[1]}
        </>
      )}
    </TypographyTitle>
  </Row>
);
